
import request from '@/utils/request'
// 个人信息上传
export const postWebBusiness = data => {
  return request({
    url: "/app/web/business",
    method: "post",
    data
  });
};
